import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import PageHero from "../components/PageHero";

export default function NotFound() {
  return (
    <>
      <Helmet>
        <title>Page Not Found — Instafrnd</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <PageHero
        eyebrow="404"
        title="This page found no IF."
        subtitle="The page you're looking for doesn't exist or has moved. Let's get you back to finding your people."
      />
      <section className="section-pad" style={{ textAlign: "center" }}>
        <div className="wrap">
          <Link className="btn btn-primary" to="/">← Back to Home</Link>
        </div>
      </section>
    </>
  );
}
